import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-deposit",
  "use": "icon-deposit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-deposit\"><path d=\"M836 939.8H114.8c-59.7 0-108.3-48.6-108.3-108.3V179.1C6.5 119.5 55.1 71 114.8 71h724.5c59.7 0 108.3 48.6 108.3 108.3v106.1c0 19.9-16.1 36.1-36.1 36.1s-36.1-16.2-36.1-36.1V179.2c0-19.9-16.2-36.1-36.1-36.1H114.8c-19.9 0-36.1 16.2-36.1 36.1v652.4c0 19.9 16.2 36.1 36.1 36.1H836c19.9 0 36.1-16.2 36.1-36.1V720c0-20 16.1-36.1 36.1-36.1s36.1 16.1 36.1 36.1v111.6c-0.1 59.7-48.6 108.2-108.3 108.2zM645 504.2c0-19.5 15.8-35.3 35.3-35.3 19.5 0 35.3 15.8 35.3 35.3 0 19.5-15.8 35.3-35.3 35.3-19.5 0-35.3-15.8-35.3-35.3z m299.8 141.9H584c-39.8 0-72.2-32.4-72.2-72.2V429.6c0-39.8 32.4-72.2 72.2-72.2h360.9c39.8 0 72.2 32.4 72.2 72.2V574c-0.1 39.8-32.5 72.1-72.3 72.1zM584 429.6V574h360.9l-0.1-144.3H584z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/deposit.svg
// module id = 7Mtr
// module chunks = 9